export default __webpack_public_path__ + "static/media/cchub.95bfab08.jpg";